import { injectIntl } from 'react-intl';

import UnitLinks from './UnitLinks';

export default injectIntl(UnitLinks);
